{
	"title": "Nova",
	"subtitle": "WSL helpdesk · answers from this workspace and GMS",
	"open": "Ask Nova",
	"close": "Close Nova",
	"newChat": "New chat",
	"placeholder": "Ask Nova…",
	"send": "Send",
	"thinking": "Looking it up…",
	"you": "You",
	"assistant": "Nova",
	"records": {
		"heading_one": "{{count}} record",
		"heading_other": "{{count}} records",
		"shown": "Showing {{shown}} of {{total}}",
		"noPhoto": "No photo",
		"openAll": "Open the list in GMS",
		"empty": "No records match."
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"recordsLink_one": "Open this record in GMS",
	"recordsLink_other": "Open these {{count}} records in GMS",
	"guide": {
		"openInGms": "Start in GMS"
	},
	"report": {
		"records_one": "{{count}} record",
		"records_other": "{{count}} records",
		"download": "Download PDF",
		"preparing": "Preparing…"
	},
	"limitNote": "Nova can make mistakes. Check important numbers in GMS.",
	"unavailable": "Nova isn't available right now. If it keeps happening, the API key may not be set up yet."
}
